import { render, staticRenderFns } from "./CopyChip.vue?vue&type=template&id=189d4263&"
import script from "./CopyChip.vue?vue&type=script&lang=js&"
export * from "./CopyChip.vue?vue&type=script&lang=js&"
import style0 from "./CopyChip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports